import { render, staticRenderFns } from "./NovelDetailView.vue?vue&type=template&id=52a16442&scoped=true&"
import script from "./NovelDetailView.vue?vue&type=script&lang=js&"
export * from "./NovelDetailView.vue?vue&type=script&lang=js&"
import style0 from "./NovelDetailView.vue?vue&type=style&index=0&id=52a16442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a16442",
  null
  
)

export default component.exports